<template>
    <div>
        <div class="m-d-16">
            <div class="f-bold f-16 f-c-black m-d-4">
                Daftar Penggunaan inventori
            </div>
            <div class="f-13 f-c-midgrey">
                Penggunaan stok inventori pada transaksi ini
            </div>
        </div>
        <div class="border rounded-lg">
            <div v-for="(item, index) in showedInventory" :key="index" :class="` ${index != 0 && 'border-top'} p-y-8 p-x-16`">
                <div class="f-13 d-flex justify-content-between">
                    <div>
                        {{item.nama}}
                    </div>
                    <div>
                        {{item.qty}} {{item.data_satuan.nama}}
                    </div>
                </div>
                <div class="f-12 f-c-midgrey d-flex justify-content-between">
                    <div>
                        {{item.merk.nama}}
                    </div>
                    <div>
                        Layanan: {{item.layanan.nama}}
                    </div>
                </div>
            </div>
            <div v-if="inventory.length > 5" class="border-top d-flex justify-content-between p-y-8 p-x-16">
                <div class="f-12 f-c-midgrey">
                    dan {{inventory.length - 5}} inventory lainnya...
                </div>
                <div class="flex justify-content-between f-c-blue" @click="openModal()">
                    <a >Lihat Detail</a>
                    <i class="fas fa-arrow-right f-12 p-l-2" style="padding-left: 4px"/>
                </div>
            </div>
        </div>
        <SOModalConfirm
            ref="modalInventory"
            is-hide-footer
            title="Detail Penggunaan Inventori"
        >
            <template v-slot:body>
                <div>
                    <div class="f-c-midgrey m-d-12">
                        <i class="fas fa-arrow-down f-12"/>
                        <span>
                            Total {{inventory.length}} Inventori
                        </span>
                    </div>
                    <div class="border rounded-lg">
                        <div v-for="(item, index) in inventory" :key="index" :class="` ${index != 0 && 'border-top'} p-y-8 p-x-16`">
                            <div class="f-13 d-flex justify-content-between">
                                <div>
                                    {{item.nama}}
                                </div>
                                <div>
                                    {{item.qty}} {{item.data_satuan.nama}}
                                </div>
                            </div>
                            <div class="f-12 f-c-midgrey d-flex justify-content-between">
                                <div>
                                    {{item.merk.nama}}
                                </div>
                                <div>
                                    Layanan: {{item.layanan.nama}}
                                </div>
                            </div>
                        </div>
                    </div>    
                </div>
            </template>

        </SOModalConfirm>
    </div>
</template>
<script>
import SOModalConfirm from '@/so-components/global/modal/SOModalConfirm.vue';
    export default {
  components: { SOModalConfirm },
        name: 'InventoryTransaksi',
        props: {
            inventory: Array
        },
        computed: {
            //get only 5 first item inventory
            showedInventory() {
                return this.inventory.slice(0, 5);
            }
        },
        methods: {
            openModal() {
                this.$refs.modalInventory.open();
            }
        }
    }
</script>
<style scoped>
</style>